"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zoomToTrain = exports.newGetLastUpdatedText = exports.newGetDelayText = exports.metersToMPH = exports.getTrackToDisplay = exports.getDelayClass = exports.formatTimestamp = exports.formatPlaybackFilename = exports.didPassZoomLevel = exports.createTrainPositionLookup = exports.calculatePoints = void 0;
var _constants = require("./constants");
var _reactBootstrap = require("react-bootstrap");
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
var _dateFns = require("date-fns");
var _dateFnsTz = require("date-fns-tz");
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var didPassZoomLevel = function didPassZoomLevel(lastZoom, newZoom) {
  var result = false;
  var zoomThresholds = [_constants.STATION_LABEL_ZOOM, _constants.INTERLOCKING_ZOOM, _constants.BUS_STOP_ZOOM, _constants.LINE_LABEL_ZOOM, _constants.PARKING_LOT_ZOOM, _constants.TRAIN_STOP_ZOOM];
  zoomThresholds.forEach(function (zoomValue) {
    if (lastZoom < zoomValue && newZoom >= zoomValue || lastZoom >= zoomValue && newZoom < zoomValue) {
      result = true;
    }
  });
  return result;
};
exports.didPassZoomLevel = didPassZoomLevel;
var zoomToTrain = function zoomToTrain(layer, map, trainId) {
  var source = layer.getSource();
  var trainFeature = source ? source.getFeatureById(trainId) : null;
  if (trainFeature) {
    return map.getView().setCenter(trainFeature.getGeometry().getCoordinates());
  }
};
exports.zoomToTrain = zoomToTrain;
var getDeviationClassName = function getDeviationClassName(timeDiff) {
  var output = '';
  if (timeDiff = 0) {
    return output;
  }
  timeDiff < 0 ? output = 'train-early' : output = 'train-late';
  return output;
};
var getTimesToDisplay = function getTimesToDisplay(arrival, departure) {
  if (arrival === departure) {
    return arrival;
  }
  return "".concat(arrival, " / ").concat(departure);
};
var generateTableCell = function generateTableCell(arrivalTime, departureTime, deviation) {
  var textContent = getTimesToDisplay(arrivalTime, departureTime);
  return;
};
var getTrackToDisplay = function getTrackToDisplay(scheduled, actual) {
  if (!actual) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "scheduled-track"
    }, scheduled);
  }
  if (scheduled === actual) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "track-row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "scheduled-track"
    }, scheduled), ' : ', /*#__PURE__*/_react["default"].createElement("div", {
      className: "actual-track-same"
    }, actual));
  }
  if (scheduled !== actual) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "track-row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "light-grey-italic"
    }, scheduled), ' : ', /*#__PURE__*/_react["default"].createElement("div", {
      className: "actual-track-different"
    }, actual));
  }
};
exports.getTrackToDisplay = getTrackToDisplay;
var createTrainPositionLookup = function createTrainPositionLookup(trainArray) {
  var output = trainArray.reduce(function (prev, current) {
    prev[current.properties.vehicle] = {
      // i just flipped this 12 pm sep 7
      latLon: [[current.properties.longitude, current.properties.latitude]]
    };
    return prev;
  }, {});
  return output;
};
exports.createTrainPositionLookup = createTrainPositionLookup;
var calculatePoints = function calculatePoints(start, end, slices, didTrainMove) {
  // y = mx + b
  var rise = end[1] - start[1];
  var run = end[0] - start[0];
  var m = rise / run;
  var b = start[1] - start[0] * m;
  // slices will be equal subdivisions from x1 to x2, and the y will be derived from them
  var distance = Math.abs(start[0] - end[0]);
  var stepSize = parseFloat(parseFloat(distance / slices));
  var output = [];
  var test = 0;
  var currentStep = start[0];
  for (var i = 0; i < slices; i++) {
    if (start[0] > end[0]) {
      // i need to get smaller
      currentStep = parseFloat(parseFloat(currentStep - stepSize.toFixed(6)));
    } else {
      // i need to get bigger
      currentStep = parseFloat(parseFloat(currentStep + stepSize.toFixed(6)));
    }
    //current step is my x
    // get the y
    var y = m * currentStep + b;
    var newCoords = [parseFloat(currentStep.toFixed(6)), parseFloat(y.toFixed(6))];
    output.push(newCoords);
  }
  return output.reverse();
};
exports.calculatePoints = calculatePoints;
var formatTimestamp = function formatTimestamp(timeString, showSeconds) {
  var output = '';
  if (!timeString) {
    return output;
  }
  var am = timeString.includes('A');
  var timeArray = timeString.split(':');
  var secondsOnly = timeArray[2].split(' ');
  output += timeArray[0].replace('0', '');
  output += ":".concat(timeArray[1]);
  if (showSeconds) {
    output += ":".concat(secondsOnly[0]);
  }
  am ? output += 'a' : output += 'p';
  return output;
};
exports.formatTimestamp = formatTimestamp;
var metersToMPH = function metersToMPH(speedMeters) {
  if (!speedMeters) {
    return 0;
  }
  return Math.floor(speedMeters * 2.23694);
};
exports.metersToMPH = metersToMPH;
var newGetDelayText = function newGetDelayText(delay) {
  if (!delay) {
    return 'on time';
  }
  if (delay > 0) {
    return "".concat(delay, " min").concat(delay > 1 ? 's' : '', " late");
  } else if (delay < 0) {
    return "".concat(delay * -1, " min").concat(delay < -1 ? 's' : '', " early");
  }
};
exports.newGetDelayText = newGetDelayText;
var getDelayClass = function getDelayClass(delay) {
  if (!delay) {
    return 'early-text';
  }
  if (delay > 0) {
    return 'late-text';
  } else if (delay <= 0) {
    return 'early-text';
  }
};
exports.getDelayClass = getDelayClass;
var newGetLastUpdatedText = function newGetLastUpdatedText(time, source) {
  var timeResult = 'Unknown';
  var viaResult = 'Unknown';
  if (!time && !source) {
    return 'No GPS timestamp available.';
  }
  if (time) {
    // we get time in seconds, need ms
    time = time * 1000;
    var updateTimeMoment = (0, _moment["default"])(time);
    if (updateTimeMoment && updateTimeMoment.isValid()) {
      var nowMoment = (0, _moment["default"])();
      var timeDiff = nowMoment.diff(updateTimeMoment);
      var timeDuration = _moment["default"].duration(timeDiff);
      if (timeDuration.as('seconds') < 60) {
        timeResult = 'just now';
      } else if (timeDuration.as('days') > 24) {
        timeResult = "".concat(Math.floor(timeDuration.as('days')), " days ago");
      } else {
        timeResult = updateTimeMoment.fromNow();
      }
      if (source) {
        viaResult = source;
      }
    }
  }
  return {
    time: timeResult,
    via: viaResult
  };
};
exports.newGetLastUpdatedText = newGetLastUpdatedText;
var formatPlaybackFilename = function formatPlaybackFilename(filename) {
  var dateString = filename.split('.')[0];
  var dateValues = dateString.split('/').map(function (v) {
    return parseInt(v);
  });
  var date = new Date(Date.UTC(dateValues[0], dateValues[1] - 1, dateValues[2], dateValues[3], dateValues[4], dateValues[5]));
  var zonedDate = (0, _dateFnsTz.utcToZonedTime)(date, 'America/New_York');
  var formattedDate = (0, _dateFns.format)(zonedDate, 'M/dd/yy hh:mm:ss');
  return {
    dateString: dateString,
    formattedDate: formattedDate,
    zonedDate: zonedDate
  };
};
exports.formatPlaybackFilename = formatPlaybackFilename;